export class ListSqlEnginesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sqlEngines",
            "baseName": "sqlEngines",
            "type": "Array<SqlEngine>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSqlEnginesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
